import { useEffect, useRef } from 'react';
import { auth } from '../services/firebase';

/**
 * Hook para gerenciar persistência de sessão e auto-refresh de tokens
 * Mantém o usuário logado o máximo possível para reduzir custos de SMS
 */
export function useSessionPersistence() {
  const refreshIntervalRef = useRef(null);

  useEffect(() => {
    const startAutoRefresh = (user) => {
      if (!user || !auth.currentUser) return;

      // Limpa intervalo anterior
      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
      }

      // Auto-refresh a cada 50 minutos (token expira em 60)
      // Isso evita que o usuário seja deslogado durante o uso
      const refreshInterval = 50 * 60 * 1000; // 50 minutos em ms

      refreshIntervalRef.current = setInterval(async () => {
        try {
          // Força refresh do token
          await auth.currentUser.getIdToken(true);
          console.log('[SessionPersistence] Token refreshed at', new Date().toLocaleTimeString());
        } catch (error) {
          console.error('[SessionPersistence] Erro ao renovar token:', error);
          // Se falhar, deixa o Firebase gerenciar naturalmente
        }
      }, refreshInterval);
    };

    // Monitora mudanças de autenticação
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        startAutoRefresh(user);
      } else {
        if (refreshIntervalRef.current) {
          clearInterval(refreshIntervalRef.current);
          refreshIntervalRef.current = null;
        }
      }
    });

    return () => {
      unsubscribe();
      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
      }
    };
  }, []);
}

/**
 * Força logout explícito (quando o usuário clica em "sair")
 */
export async function performLogout() {
  try {
    await auth.signOut();
    console.log('[SessionPersistence] Usuário deslogado');
  } catch (error) {
    console.error('[SessionPersistence] Erro ao fazer logout:', error);
    throw error;
  }
}
